import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./section-darkmode-podcast-highlight-v2.scss"

const SectionDarkmodePodcastHighlightV2 = ({
  applePodcastLink,
  image,
  spotifyLink,
  text,
  title,
  youtubeLink,
}) => {
  return (
    <section className="section-darkmode-podcast-highlight-v2">
      <div className="container-v2">
        {image?.fluid && (
          <div className="section-darkmode-podcast-highlight-v2--image">
            <Image image={image?.fluid} />
          </div>
        )}
        <div className="section-darkmode-podcast-highlight-v2--content">
          <div className="section-darkmode-podcast-highlight-v2--content-header">
            {title && (
              <h2 className="section-darkmode-podcast-highlight-v2--title">
                <TextLockupV2>{title}</TextLockupV2>
              </h2>
            )}
            {text?.childrenMarkdownRemark?.[0]?.html && (
              <div
                className="section-darkmode-podcast-highlight-v2--text"
                dangerouslySetInnerHTML={{
                  __html: text?.childrenMarkdownRemark?.[0]?.html,
                }}
              />
            )}
          </div>

          <div className="section-darkmode-podcast-highlight-v2--sub-title-links-wrapper">
            <h3 className="section-darkmode-podcast-highlight-v2--sub-title">
              Listen on:
            </h3>
            <div className="section-darkmode-podcast-highlight-v2--links">
              {spotifyLink && (
                <p className="section-darkmode-podcast-highlight-v2--cta-button-wrapper section-darkmode-podcast-highlight-v2--spotify-button">
                  <ButtonV2
                    accessibilityLabel="Spotify"
                    className={getButtonClasses("Outline White", "small")}
                    href={spotifyLink}
                    key={spotifyLink}
                    newWindow={true}
                    showArrow={false}
                    text="Spotify"
                  />
                </p>
              )}
              {applePodcastLink && (
                <p className="section-darkmode-podcast-highlight-v2--cta-button-wrapper section-darkmode-podcast-highlight-v2--apple-podcasts-button">
                  <ButtonV2
                    accessibilityLabel="Apple Podcasts"
                    className={getButtonClasses("Outline White", "small")}
                    href={applePodcastLink}
                    key={applePodcastLink}
                    newWindow={true}
                    showArrow={false}
                    text="Apple Podcasts"
                  />
                </p>
              )}
              {youtubeLink && (
                <p className="section-darkmode-podcast-highlight-v2--cta-button-wrapper section-darkmode-podcast-highlight-v2--youtube-button">
                  <ButtonV2
                    accessibilityLabel="YouTube"
                    className={getButtonClasses("Outline White", "small")}
                    href={youtubeLink}
                    key={youtubeLink}
                    newWindow={true}
                    showArrow={false}
                    text="YouTube"
                  />
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

SectionDarkmodePodcastHighlightV2.propTypes = {
  applePodcastLink: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  spotifyLink: PropTypes.string.isRequired,
  text: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  youtubeLink: PropTypes.string.isRequired,
}
export default SectionDarkmodePodcastHighlightV2
